import { ServerClient } from 'common/utils/http/http-clients';
import { GateOperationEnum, ICardAccessPanel, RelayOperationEnum } from './card-access.service.types';

class CardAccessService {
  async toggleRelay(panelNumber: string, relayNumber: string, operation: RelayOperationEnum): Promise<void> {
    const res = await ServerClient.post<void>(`/card-access/gates/panels/${panelNumber}/relays/${relayNumber}`, {
      operation,
    });
    return res?.data;
  }

  async toggleGate(panelNumber: string, readerNumber: string, operation: GateOperationEnum): Promise<void> {
    const res = await ServerClient.post<void>(`/card-access/gates/panels/${panelNumber}/readers/${readerNumber}`, {
      operation,
    });
    return res?.data;
  }

  async generateSmartPlateIds(syncWithCardAccessSystem: boolean): Promise<void> {
    await ServerClient.post<void>('/card-access/smart-plate-id/generate', JSON.stringify(syncWithCardAccessSystem), {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  async getPanels() {
    const result = await ServerClient.get<ICardAccessPanel[]>('card-access/panels');
    return result.data;
  }
}

export const cardAccessService = new CardAccessService();
export default cardAccessService;
